module.exports = __webpack_public_path__ + "static/media/SOIKAOFA_MENU-normal.8c600d47.png";